import { type CSSProperties, memo, useContext, useMemo } from 'react';

import { cn } from '@/lib/cn';

import TabsContext from './TabContext';

type TabBodyProps = {
  style?: CSSProperties;
  className?: string;
};

const TabBody = (props: TabBodyProps) => {
  const { selectedTabId, tabs } = useContext(TabsContext);
  const selectedTab = useMemo(() => {
    return tabs.find((tab) => tab.id === selectedTabId);
  }, [tabs, selectedTabId]);

  return (
    <>
      {selectedTab?.content && (
        <div className={cn('flex w-full', props.className)} style={props.style}>
          {selectedTab?.content}
        </div>
      )}
    </>
  );
};

export default memo(TabBody);
